tasks-today
  .task-wrap.row
    .left-wrap.col-md-6
      .group
        span.index { locale().phase }:&nbsp;
        span.value.label.label-default(style="background: {getPhaseData(opts.phase_id).colorcode }") { getPhaseData(opts.phase_id).name }
      .group
        span.index { locale().responsible }:&nbsp;
        span.value { opts.responsible_text }
      .group
        span.index { locale().schedules }:&nbsp;
        span.value
          tasks-schedules-text(tag-scope="{this.tagScope}")
      .taskable(if="{ taskableData }")
        .group(if="{ taskableData.planned_num }")
          span.index(if="{ taskableData.klass == 'Tasks::Casting' }") { locale().casting.planned_num }:&nbsp;
          span.value { taskableData.planned_num }
        .group(if="{ taskableData.location_id }")
          span.index { locale().delivery.location }:&nbsp;
          span.value { location() }
        .group(if="{ taskableData.locations_person_id }")
          span.index { locale().delivery.locations_person }:&nbsp;
          span.value { locationName() } { locale().delivery.polite }
    .right-wrap.col-md-6
      .group
        tasks-schedules-calendar(tag-scope="{this.tagScope}")
      .group
        span.index { locale().memo}:&nbsp;
        pre.value.desc { opts.memo }
  script(type="typescript").
    this.mixin('tasks.today');
  style(scoped).
    .index {
      font-weight: bold;
    }
    .group {
      margin-bottom: .5rem;
    }
    
